"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "capraia-e-limite": {
    "98eec14c": [{
      "hkey": "2d41c9ab",
      "slug": "capraia-e-limite",
      "name": "Capraia e Limite",
      "primary": true,
      "skipSearch": false
    }],
    "castellina": [{
      "hkey": "2d41c9ab",
      "slug": "capraia-e-limite",
      "name": "Capraia e Limite",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6bccb7e8": [{
      "hkey": "2d41c9ab",
      "slug": "capraia-e-limite",
      "name": "Capraia e Limite",
      "primary": true,
      "skipSearch": false
    }],
    "conio": [{
      "hkey": "2d41c9ab",
      "slug": "capraia-e-limite",
      "name": "Capraia e Limite",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;